import {NgModule} from '@angular/core';
import {SegmentWrapperComponent} from './item';
import {IonicModule} from '@ionic/angular';
import {NgClass, NgForOf, NgIf} from '@angular/common';
import {SegmentComponentModule} from '../segment/item.module';

@NgModule({
    imports: [
        IonicModule,
        NgForOf,
        NgIf,
        SegmentComponentModule,
        NgClass
    ],
  exports: [
    SegmentWrapperComponent
  ],
  declarations: [SegmentWrapperComponent],
  providers: [],
})
export class SegmentWrapperComponentModule {
}
